import { EducationLevelType } from '../client/knowledgeAndExperienceEntity';

export enum LegalClientFinancialInstrumentType {
  /** Акции */
  Stocks = 'Stocks',
  /** Долговые ценные бумаги или облигации */
  Bonds = 'Bonds',
  /** Паи в коллективных инвестиционных фондах */
  MutualFunds = 'MutualFunds',
  /** Структурные продукты */
  StructuredProducts = 'StructuredProducts',
  /** Деривативы */
  Derivatives = 'Derivatives',
  /** Другое */
  Other = 'Other',
}

export interface LegalClientKnowledgeAndExperienceEntity {
  financialInstruments?: LegalClientFinancialInstrumentType[];
  hasQualifiedOfficersForInvestmentDecisions: boolean;
  educationLevel?: EducationLevelType;
  heldFinancialPositionInLast5Years?: boolean;
  otherFinancialInstrument?: string;
}
